<template>
  <div>
    <div class="d-flex mb-9">
      <router-link :to="{name: 'create_admin_user', params: {adminId: organization.adminId}}" class="ml-auto">
        <vs-button color="success" type="filled">añadir usuario</vs-button>
      </router-link>
    </div>
    <table class="n-table">
      <thead>
        <th>Nombre y Apellido</th>
        <th>Email</th>
        <th>Fecha de creación</th>
        <th>Establecimientos</th>
        <th>Estado</th>
      </thead>
      <tbody>
        <tr v-for="user in organization.users" :key="user.id">
          <td data-label="Nombre y Apelldio">{{ user.firstname }} {{ user.lastname }}</td>
          <td data-label="Email">{{ user.email }}</td>
          <td data-label="Fecha de creación">{{ localeDate(user.createdAt) }}</td>
          <td data-label="Establecimientos">
            <span v-for="(estab, index) in organization.establishments" :key="index">
              <span v-if="estab.users.map(u => u.id).includes(user.id)">{{ index ? ', ' : ''}}{{ estab.name }} ({{ $t(`organization.userRoles.${estab.users.find(u => u.id == user.id).establishmentRole}`) }})</span>
            </span>
          </td>
          <td data-label="Estado"><vs-switch v-model="user.active" @change="changeUserState(user.id, user.active)" color="success" /></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { mapMutations, mapState } from 'vuex'

axios.defaults.headers.common['referer-id'] = new Date().toLocaleString().replace(/[^\d]/g, '') + parseInt(Math.random() * 100000)

const changeUserState = gql`
  mutation changeUserState($currentUserToken: String!, $userId: Int!, $active: Boolean!) {
    changeUserState (currentUserToken: $currentUserToken, userId: $userId, active: $active) {
      code
      codes
      message
      success
    }
  }
`



export default {
  name: 'user-settings-backend',
  computed: {
    ...mapState({
      currentUser: state => state.User.currentUser
    })
  },
  data() {
    return {
      users: []
    }
  },
  props: {
    organization: {
      type: Object,
      required: true
    }
  },
  beforeMount() {
    this.organization.users
  },
  methods: {
    getEstablish(arr) {
      return arr.map( est => est.name).join(', ')
    },
    localeDate (str) {
      return new Date(Date.parse(str) + 3.6e+6*3).toLocaleDateString()
    //  return (new Date(str.replace(/-0300/, '').trim())).toLocaleString()
    },
    changeUserState(id, active) {
      axios.post(`${process.env.VUE_APP_GRAPH_PATH}`, {
        query: print(changeUserState),
        variables: {
          currentUserToken: localStorage.getItem('USER_TOKEN'),
          userId: id,
          active: active
        }
      }).then(res => {
        if (!res.data.errors) {
          console.log(active)
        } else {
          console.log(res.data.errors)
        }
      })
    },
  }

}
</script>

<style scoped>
.mb-9 {
  margin-bottom: 9px;
}
.ml-auto {
  margin-left: auto;
}
</style>
